const devboxPorts = {
  account: 3010,
  admin: 3010,
  api: 3000,
  auth: 4112,
  buckets: 4106,
  commander: 5140,
  components: 5140,
  data: 4107,
  delivery: 3420,
  example: 4100,
  experiments: 4114,
  finances: 4105,
  marketing: 4005,
  messenger: 4122,
  reservaspos: 5140,
  sales: 4117,
  spaces: 4126,
  web: 3010,
  www: 3010
}

function getDevboxDomain() {
  const hostname = String(window.location.hostname)
  const marker = '.devbox.'
  const index = hostname.indexOf(marker)
  if (index === -1) return null

  const labels = hostname.slice(0, index).split('.')
  const name = labels[labels.length - 1]
  if (!name) return null

  return `${name}${hostname.slice(index)}`
}

function getDevboxURL(subdomain) {
  const domain = getDevboxDomain()
  if (!domain) return null

  const port = devboxPorts[subdomain]
  if (port) return `http://${window.location.hostname}:${port}`

  return `http://${subdomain}.${domain}`
}

export default function getCustom(subdomain, forceProtocol) {
  const devboxURL = getDevboxURL(subdomain)
  if (devboxURL) return devboxURL

  if (!process.env.REACT_APP_DOMAIN) return
  const protocol = forceProtocol || process.env.REACT_APP_USE_HTTP ? 'http' : 'https'
  return `${protocol}://${subdomain}.${process.env.REACT_APP_DOMAIN}`
}
